import { inject } from '@angular/core';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
export class AgentUserPreferencesService {
    constructor() {
        this._ajaxService = inject(AjaxService);
        this._urlsService = inject(UrlsService);
    }
    get() {
        return this._ajaxService.getDataObserveBody(this._urlsService.AGENT.PREFERENCES);
    }
    save(preferences) {
        return this._ajaxService.postDataObserveBody(this._urlsService.AGENT.PREFERENCES, preferences);
    }
}
AgentUserPreferencesService.ɵfac = function AgentUserPreferencesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserPreferencesService)(); };
AgentUserPreferencesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentUserPreferencesService, factory: AgentUserPreferencesService.ɵfac, providedIn: 'root' });
